import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Switch, Route } from 'react-router-dom'

import MobileHeader from '../components/MobileHeader';
import TopMenu from '../components/TopMenu';
import Home from '../components/Home';
import Company from '../components/Company';
import History from '../components/History';
import SalesItems from '../components/SalesItems';
import Contact from '../components/Contact';
import NLMenu from '../components/NLMenu';
import Business from '../components/Business';
import NotFound from '../components/NotFound';

import './App.css';

export default class App extends React.Component {

  static propTypes = {
    className: PropTypes.string
  };

  state = {
    isMenuOpen: false,
    isBusinessOpen: false
  };

  render() {
    return (
      <div className={classnames('App', this.props.className)}>
        <MobileHeader
          onClickMenuBtn={this._onClickMenuBtn}
        />
        <TopMenu/>
        <Switch>
          <Route exact path="/" component={Home}/>
          <Route path="/company" children={() => (
            <Company
              onClickViewBusinessButton={this._onClickViewBusinessButton}
            />
          )}/>
          <Route path="/history" component={History}/>
          <Route path="/sales-items" component={SalesItems}/>
          <Route path="/contact" component={Contact}/>
          <Route component={NotFound}/>
        </Switch>
        <NLMenu
          isOpen={this.state.isMenuOpen}
          onClickClose={this._onClickClose}
        />
        {
          this.state.isBusinessOpen &&
          <div
            className="App__businessTable"
            onClick={this._onClickBusiness}
            ref={(el) => { this._businessTableEl = el; }}>
            <div
              className="App__businessTableCell"
              ref={(el) => { this._businessTableCellEl = el; }}>
              <Business
                onClickClose={this._onClickBusinessClose}
              />
            </div>
          </div>
        }
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setState({
        isBusinessOpen: false
      });
    }
  }

  _onClickMenuBtn = () => {
    this.setState({
      isMenuOpen: !this.state.isMenuOpen
    });
  };

  _onClickClose = () => {
    if (this.state.isMenuOpen) {
      this.setState({
        isMenuOpen: false
      });
    }
  };

  _onClickViewBusinessButton = () => {
    this.setState({
      isBusinessOpen: true
    });
  };

  _onClickBusiness = (evt) => {
    if (this._businessTableCellEl === evt.target || this._businessTableEl === evt.target) {
      this.setState({
        isBusinessOpen: false
      });
    }
  };

  _onClickBusinessClose = () => {
    this.setState({
      isBusinessOpen: false
    });
  };

}



// WEBPACK FOOTER //
// ./src/components/App.js